import { Suspense } from 'react'
import { useModal } from '../../context/ModalContext'
import { MODAL_REGISTRY } from './registry'

// Mounted once inside the authenticated shell. Renders whatever modals are on
// the stack; each modal receives its payload props plus a `close` callback.
function ModalRoot() {
  const { stack, closeModal } = useModal()

  if (!stack.length) return null

  return (
    <>
      {stack.map((entry, index) => {
        const ModalComponent = MODAL_REGISTRY[entry.key]
        if (!ModalComponent) return null

        return (
          <Suspense key={index} fallback={null}>
            <ModalComponent {...entry.props} close={closeModal} />
          </Suspense>
        )
      })}
    </>
  )
}

export default ModalRoot
